import { InfoCircleOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_IDEA,
  GET_ME,
  Idea,
  Me,
  RESPOND_TEAM_INVITE,
} from '@frontend/data-access';
import { Alert, Button } from 'antd';
import useTranslation from 'next-translate/useTranslation';

export function IdeaDetailTeamInvite({ idea }: { idea: Idea }) {
  const { t } = useTranslation('common');
  const { data: meData } = useQuery<{ me: Me }>(GET_ME);
  const invites = idea?.applicants.filter(
    (a) =>
      a.status === 'PENDING' &&
      a.userId === meData?.me.id &&
      a.type === 'INVITE'
  );

  const [accept, { loading: acceptLoading }] = useMutation(
    RESPOND_TEAM_INVITE,
    { refetchQueries: [{ query: GET_IDEA, variables: { ideaId: idea.id } }] }
  );
  const [reject, { loading: rejectLoading }] = useMutation(
    RESPOND_TEAM_INVITE,
    { refetchQueries: [{ query: GET_IDEA, variables: { ideaId: idea.id } }] }
  );

  const onClickRespond = (status: string) => {
    switch (status) {
      case 'REJECTED':
        reject({ variables: { id: invites[0].id, status: status } });
        break;
      case 'APPROVED':
        accept({ variables: { id: invites[0].id, status: status } });
        break;
      default:
        break;
    }
  };

  if (invites.length) {
    return (
      <div>
        <Alert
          className="!bg-gray-100 !p-4 !border-gray-500"
          message={
            <div className="text-primary-600 flex items-center gap-2">
              <InfoCircleOutlined />
              {t('invited_to_the_team')}
            </div>
          }
          description={`You have been invited to the team of ${
            idea.anonymous ? 'Anonymous member' : idea.createdBy?.fullName
          } for this idea in Ideation Bridge. `}
          action={
            <div className="space-x-2">
              <Button
                danger
                type="text"
                shape="round"
                loading={rejectLoading}
                onClick={() => onClickRespond('REJECTED')}
              >
                {t('reject')}
              </Button>
              <Button
                type="primary"
                shape="round"
                loading={acceptLoading}
                onClick={() => onClickRespond('APPROVED')}
                className="!bg-green-500 !hover:bg-green-300 !border-none"
              >
                {t('accept')}
              </Button>
            </div>
          }
        />
      </div>
    );
  } else {
    return null;
  }
}

export default IdeaDetailTeamInvite;
